module.exports = __webpack_public_path__ + "img/phoneEle.72fe06b6.svg";